var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllCuisine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.663 18.69C24.0167 18.69 23.4996 18.186 23.4996 17.556V10.29C23.4996 9.66001 24.0167 9.15601 24.663 9.15601H32.2471C32.8934 9.15601 33.4105 9.66001 33.4105 10.29V17.556C33.4105 18.186 32.8934 18.69 32.2471 18.69H24.663Z",
    fill: "#FB8D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9399 22.9739L23.5015 27.6359C23.243 27.8879 23.243 28.3499 23.5015 28.6019L27.9399 33.2639C28.2415 33.5579 28.7155 33.5579 29.0172 33.2639L33.4556 28.6019C33.7141 28.3499 33.7141 27.8879 33.4556 27.6359L29.0172 22.9739C28.7155 22.6799 28.1984 22.6799 27.9399 22.9739Z",
    fill: "#FB8D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6646 32.8439C17.4252 32.8439 19.6631 30.6626 19.6631 27.9719C19.6631 25.2811 17.4252 23.0999 14.6646 23.0999C11.9039 23.0999 9.66602 25.2811 9.66602 27.9719C9.66602 30.6626 11.9039 32.8439 14.6646 32.8439Z",
    fill: "#FB8D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2693 10.7939L14.1044 8.65188C14.4491 8.44188 14.88 8.44188 15.2679 8.65188L19.103 10.7939C19.4477 11.0039 19.6631 11.3819 19.6631 11.7599V16.0439C19.6631 16.4219 19.4477 16.7999 19.103 17.0099L15.2679 19.1519C14.9231 19.3619 14.4922 19.3619 14.1044 19.1519L10.2693 17.0099C9.92456 16.7999 9.66602 16.4219 9.66602 16.0439V11.7599C9.66602 11.3399 9.92456 10.9619 10.2693 10.7939Z",
    fill: "#FB8D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCuisine);
export default __webpack_public_path__ + "static/media/AllCuisine.278683037f386a6aefb54597f03f72c9.svg";
export { ForwardRef as ReactComponent };